import React, { useState } from 'react'
import { OtsideClickClosingWrapper } from '../../../common/EmojiReactionPicker/OtsideClickClosingWrapper'
import { message, Popconfirm } from 'antd';

export const CustomePopConfirm = ({ callBackData,children,
    onConfirm, onCancel, okText, cancelText, icon
    , className, overlayClassName, title, description, canDelete }) => {
    const [open, setOpen] = useState(false);
    const handleClick = (e) => {
        if (!canDelete) {
            e.stopPropagation();
            message.error("Permission denied");
            return;
        }
        setOpen(true);
    };
    return (
        <OtsideClickClosingWrapper close={() => {
            setOpen(false);
        }}>
            <span onClick={handleClick}>
            <Popconfirm
                className={className}
                open={canDelete ? open : false}
                overlayClassName={overlayClassName}
                onConfirm={() => onConfirm(callBackData)}
                onCancel={() => {
                    onCancel();
                }}
                onOpenChange={state => {
                    setOpen(state)
                }}
                okText={okText}
                cancelText={cancelText}
                title={title}
                description={description}
                icon={icon}
            >{children}</Popconfirm>
            </span>
        </OtsideClickClosingWrapper>
    )
}
